import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import { LoadingSpinner } from "../components";

const AccountReturn = () => {
  const { setNavigateToDashboard, checkAuth } = useStateContext();

  const navigate = useNavigate();

  useEffect(() => {
    setNavigateToDashboard(false);
    checkAuth();
    setTimeout(() => {
      navigate("/account");
    }, 1000);
    clearTimeout();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <LoadingSpinner isLoading={true} />
    </>
  );
};

export default AccountReturn;
